<template>
    <Button
        :disabled="disabled"
        type="button"
        icon="pi pi-search"
        label="Cari disini"
        @click="toggle"
        aria:haspopup="true"
        aria-controls="overlay_panel"
        class="mt-1 block w-full p-button-info rounded-b-none"
    />
    <OverlayPanel ref="op" :showCloseIcon="true" id="overlay_panel">
        <DataTable
            ref="dt"
            class="p-datatable-sm text-sm"
            removableSort
            dataKey="id"
            filterDisplay="row"
            responsiveLayout="scroll"
            v-model:filters="filters"
            v-model:selection="selected_record"
            selectionMode="single"
            :value="record_list"
            :lazy="true"
            :paginator="true"
            :rows="totalRowShowed"
            :totalRecords="total_records"
            :scrollable="true"
            @page="onPaginate($event)"
            @filter="onFilter($event)"
            @rowSelect="onRowSelect"
        >
            <template #empty> Data masih kosong </template>
            <Column
                v-for="col in config.defineCols"
                :key="col.field"
                :field="col.field"
                :header="col.header"
                :ref="col.field"
                :style="col.style"
                dataType="text"
                :sortable="true"
            >
                <template #filter="{ filterModel, filterCallback }">
                    <Input
                        type="text"
                        v-model="filterModel.value"
                        @keydown.enter="filterCallback()"
                        class="p-column-filter"
                        placeholder="Cari..."
                    />
                </template>
            </Column>
        </DataTable>
    </OverlayPanel>
    <Input
        :id="config.formName"
        v-model="form.inputText"
        type="text"
        placeholder=""
        class="w-full rounded-t-none border-gray-600"
        :class="{ 'p-invalid': error }"
        readonly="true"
    />
</template>

<script>
import { defineComponent } from "vue";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import OverlayPanel from "primevue/overlaypanel";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Input from "@/Components/Input.vue";

const totalRowShowed = 5;

export default defineComponent({
    props: ["config", "disabled", "error"],
    emits: ["getInputDataGrid"],
    components: {
        Button,
        OverlayPanel,
        Checkbox,
        DataTable,
        Column,
        Input,
    },
    data() {
        return {
            totalRowShowed: totalRowShowed,
            total_records: 0,
            record_list: null,
            selected_record: [],
            filters: {},
            searchable_cols: [],
            lazyParams: {},
            form: {
                inputText: null,
            },
        };
    },
    created: function () {
        //
        this.config.defineCols.forEach((item) => {
            this.searchable_cols.push(item.field);
            this.filters[item.field] = {
                value: "",
                matchMode: "contains",
            };
        });
        this.lazyParams = {
            first: 0,
            rows: this.totalRowShowed,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
    },
    mounted() {
        this.loadLazyData();
    },
    methods: {
        toggle: function (event) {
            this.$refs.op.toggle(event);
        },
        loadLazyData: function () {
            let self = this;

            axios
                .get(route(this.config.dtSourceApiRoute.list), {
                    params: {
                        dt_params: JSON.stringify(self.lazyParams),
                        searchable_columns: JSON.stringify(
                            this.searchable_cols
                        ),
                    },
                })
                .then((res) => {
                    self.record_list = res.data.payload.data;
                    self.total_records = res.data.payload.total;
                })
                .catch(function (error) {
                    //
                })
                .then(function () {});
        },
        onFilter: function () {
            this.lazyParams.filters = this.filters;
            this.loadLazyData();
        },
        onPaginate: function (event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onRowSelect: function (event) {
            this.form.inputText = event.data[this.config.formName];
            this.$emit("getInputDataGrid", event.data);
            this.$refs.op.hide();
            this.selected_record = [];
        },
        setData: function (inputData) {
            // console.log(inputData[this.config.table][this.config.formName]);
            this.form.inputText =
                inputData[this.config.table][this.config.formName];
        },
        clear: function () {
            this.form.inputText = null;
        },
    },
});
</script>
